import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { API_BASE_URL } from '../injection-tokens';
import { ProjectCampaign } from '../models/project-campaign.model';
import { ProjectCampaignProductType } from '../models/project-campaign-product-type.model';

@Injectable({
  providedIn: 'root',
})
export class ProjectCampaignService {
  private http = inject(HttpClient);

  private apiBaseUrl = inject(API_BASE_URL);

  getAll(): Observable<ProjectCampaign[]> {
    return this.http.get<ProjectCampaign[]>(`${this.apiBaseUrl}/v1/project-campaigns`);
  }

  getProductTypesByCampaignId(campaignId: string): Observable<ProjectCampaignProductType[]> {
    return this.http.get<ProjectCampaignProductType[]>(
      `${this.apiBaseUrl}/v1/project-campaigns/${campaignId}/product-types`,
    );
  }
}
